import { render, staticRenderFns } from "./ReservationFormPopover.vue?vue&type=template&id=90d2a3f2&"
import script from "./ReservationFormPopover.vue?vue&type=script&lang=js&"
export * from "./ReservationFormPopover.vue?vue&type=script&lang=js&"
import style0 from "./ReservationFormPopover.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports